import { h } from 'preact'

export function Close() {
	return <svg class="icon-close" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.05033 1.05025L10.9498 10.9497M10.9498 1.05025L1.05033 10.9497" stroke="#1B0D5E" stroke-width="1.5" stroke-linecap="round"/>
	</svg>
}

export function Heart() {
	return <svg class="icon-heart" width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.92901 2.76461L9.6496 4.6104L10.3699 2.76452C10.966 1.23721 12.825 0.478064 14.7033 0.836511C16.5027 1.17991 18.127 2.53949 18.127 5.09314C18.127 7.60168 16.1436 11.2451 9.64946 15.1231C3.15527 11.2451 1.17188 7.60168 1.17188 5.09314C1.17188 3.77581 1.59574 2.80592 2.20984 2.12516C2.83059 1.43702 3.68258 1.00408 4.59618 0.832914C6.47634 0.480664 8.33687 1.24785 8.92901 2.76461Z" stroke="#1B0D5E" stroke-width="1.7"/>
	</svg>
}

export function ArrowDown() {
	return <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.5 1L5.5 5L9.5 1" stroke="#1B0D5E" stroke-width="1.5"/>
	</svg>
}